import { GlTooltipDirective, GlLink, GlBadge, GlIcon } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { __ } from '~/locale';
import CiCdCatalogWrapper from '/builds/gitlab/gitlab-ee/app/assets/javascripts/releases/components/ci_cd_catalog_wrapper.vue?vue3';
export default {
    name: 'ReleaseBlockTitle',
    i18n: {
        historical: __('Historical release'),
        historicalTooltip: __('This release was created with a date in the past. Evidence collection at the moment of the release is unavailable.')
    },
    components: {
        GlLink,
        GlBadge,
        GlIcon,
        CiCdCatalogWrapper
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        release: {
            type: Object,
            required: true
        }
    },
    computed: {
        selfLink () {
            return this.release._links?.self;
        }
    }
};
